
/** @type {Record<string, AssetsTeam[]>} */
const TEAMS_BY_LEAGUE = {
  nhl: [
    { name: "Anaheim Ducks", handle: "anaheim-ducks" },
    { name: "Boston Bruins", handle: "boston-bruins" },
    { name: "Buffalo Sabres", handle: "buffalo-sabres" },
    { name: "Calgary Flames", handle: "calgary-flames" },
    { name: "Carolina Hurricanes", handle: "carolina-hurricanes" },
    { name: "Chicago Blackhawks", handle: "chicago-blackhawks" },
    { name: "Colorado Avalanche", handle: "colorado-avalanche" },
    { name: "Columbus Blue Jacket", handle: "columbus-blue-jacket" },
    { name: "Columbus Blue Jackets", handle: "columbus-blue-jackets" },
    { name: "Dallas Stars", handle: "dallas-stars" },
    { name: "Detroit Red Wings", handle: "detroit-red-wings" },
    { name: "Edmonton Oilers", handle: "edmonton-oilers" },
    { name: "Florida Panthers", handle: "florida-panthers" },
    { name: "Los Angeles Kings", handle: "los-angeles-kings" },
    { name: "Minnesota Wild", handle: "minnesota-wild" },
    { name: "Montreal Canadiens", handle: "montreal-canadiens" },
    { name: "Nashville Predators", handle: "nashville-predators" },
    { name: "New Jersey Devils", handle: "new-jersey-devils" },
    { name: "New York Islanders", handle: "new-york-islanders" },
    { name: "New York Rangers", handle: "new-york-rangers" },
    { name: "Ottawa Senators", handle: "ottawa-senators" },
    { name: "Philadelphia Flyers", handle: "philadelphia-flyers" },
    { name: "Pittsburgh Penguins", handle: "pittsburgh-penguins" },
    { name: "San Jose Sharks", handle: "san-jose-sharks" },
    { name: "Seattle Kraken", handle: "seattle-kraken" },
    { name: "St. Louis Blues", handle: "st-louis-blues" },
    { name: "Tampa Bay Lightning", handle: "tampa-bay-lightning" },
    { name: "Toronto Maple Leafs", handle: "toronto-maple-leafs" },
    { name: "Utah Mammoth", handle: "utah-mammoth" },
    { name: "Vancouver Canucks", handle: "vancouver-canucks" },
    { name: "Vegas Golden Knights", handle: "vegas-golden-knights" },
    { name: "Washington Capitals", handle: "washington-capitals" },
    { name: "Winnipeg Jets", handle: "winnipeg-jets" }
  ],
  nba: [
    { name: "Atlanta Hawks", handle: "atlanta-hawks" },
    { name: "Boston Celtics", handle: "boston-celtics" },
    { name: "Brooklyn Nets", handle: "brooklyn-nets" },
    { name: "Charlotte Hornets", handle: "charlotte-hornets" },
    { name: "Chicago Bulls", handle: "chicago-bulls" },
    { name: "Cleveland Cavaliers", handle: "cleveland-cavaliers" },
    { name: "Dallas Mavericks", handle: "dallas-mavericks" },
    { name: "Denver Nuggets", handle: "denver-nuggets" },
    { name: "Detroit Pistons", handle: "detroit-pistons" },
    { name: "Golden State Warriors", handle: "golden-state-warriors" },
    { name: "Houston Rockets", handle: "houston-rockets" },
    { name: "Indiana Pacers", handle: "indiana-pacers" },
    { name: "Los Angeles Clippers", handle: "los-angeles-clippers" },
    { name: "Los Angeles Lakers", handle: "los-angeles-lakers" },
    { name: "Memphis Grizzlies", handle: "memphis-grizzlies" },
    { name: "Miami Heat", handle: "miami-heat" },
    { name: "Milwaukee Bucks", handle: "milwaukee-bucks" },
    { name: "Minnesota Timberwolves", handle: "minnesota-timberwolves" },
    { name: "New Orleans Pelicans", handle: "new-orleans-pelicans" },
    { name: "New York Knicks", handle: "new-york-knicks" },
    { name: "Oklahoma City Thunder", handle: "oklahoma-city-thunder" },
    { name: "Orlando Magic", handle: "orlando-magic" },
    { name: "Philadelphia 76ers", handle: "philadelphia-76ers" },
    { name: "Phoenix Suns", handle: "phoenix-suns" },
    { name: "Portland Trail Blazers", handle: "portland-trail-blazers" },
    { name: "Sacramento Kings", handle: "sacramento-kings" },
    { name: "San Antonio Spurs", handle: "san-antonio-spurs" },
    { name: "Toronto Raptors", handle: "toronto-raptors" },
    { name: "Utah Jazz", handle: "utah-jazz" },
    { name: "Washington Wizards", handle: "washington-wizards" }
  ],
  milb: [
    { name: "Aberdeen Ironbirds", handle: "aberdeen-ironbirds" },
    { name: "Akron Rubberducks", handle: "akron-rubberducks" },
    { name: "Akron RubberDucks", handle: "akron-rubberducks" },
    { name: "Albuquerque Isotopes", handle: "albuquerque-isotopes" },
    { name: "Amarillo Sod Poodles", handle: "amarillo-sod-poodles" },
    { name: "Arkansas Travelers", handle: "arkansas-travelers" },
    { name: "Asheville Tourists", handle: "asheville-tourists" },
    { name: "Augusta Greenjackets", handle: "augusta-greenjackets" },
    { name: "Augusta GreenJackets", handle: "augusta-greenjackets" },
    { name: "Bradenton Marauders", handle: "bradenton-marauders" },
    { name: "Buffalo Bisons", handle: "buffalo-bisons" },
    { name: "Charleston Riverdogs", handle: "charleston-riverdogs" },
    { name: "Charleston RiverDogs", handle: "charleston-riverdogs" },
    { name: "Chattanooga Lookouts", handle: "chattanooga-lookouts" },
    { name: "Chesapeake Baysox", handle: "chesapeake-baysox" },
    { name: "Columbus Clingstones", handle: "columbus-clingstones" },
    { name: "Columbus Clippers", handle: "columbus-clippers" },
    { name: "Corpus Christi Hooks", handle: "corpus-christi-hooks" },
    { name: "Delmarva Shorebirds", handle: "delmarva-shorebirds" },
    { name: "Durham Bulls", handle: "durham-bulls" },
    { name: "El Paso Chihuahuas", handle: "el-paso-chihuahuas" },
    { name: "Erie Seawolves", handle: "erie-seawolves" },
    { name: "Erie SeaWolves", handle: "erie-seawolves" },
    { name: "Everett Aquasox", handle: "everett-aquasox" },
    { name: "Everett AquaSox", handle: "everett-aquasox" },
    { name: "Fort Wayne TinCaps", handle: "fort-wayne-tincaps" },
    { name: "Fredericksburg Nationals", handle: "fredericksburg-nationals" },
    { name: "Fresno Grizzlies", handle: "fresno-grizzlies" },
    { name: "Frisco Rough Riders", handle: "frisco-rough-riders" },
    { name: "Frisco RoughRiders", handle: "frisco-roughriders" },
    { name: "Greensboro Grasshoppers", handle: "greensboro-grasshoppers" },
    { name: "Hartford Yard Goats", handle: "hartford-yard-goats" },
    { name: "Hickory Crawdads", handle: "hickory-crawdads" },
    { name: "Hillsboro Hops", handle: "hillsboro-hops" },
    { name: "Hub City Spartanburgers", handle: "hub-city-spartanburgers" },
    { name: "Hudson Valley Renegades", handle: "hudson-valley-renegades" },
    { name: "Jersey Shore Blueclaws", handle: "jersey-shore-blueclaws" },
    { name: "Jersey Shore BlueClaws", handle: "jersey-shore-blueclaws" },
    { name: "Knoxville Smokies", handle: "knoxville-smokies" },
    { name: "Las Vegas Aviators", handle: "las-vegas-aviators" },
    { name: "Lehigh Valley Ironpigs", handle: "lehigh-valley-ironpigs" },
    { name: "Lehigh Valley IronPigs", handle: "lehigh-valley-ironpigs" }
  ],
  mlb: [
    { name: "Arizona Diamondbacks", handle: "arizona-diamondbacks" },
    { name: "Atlanta Braves", handle: "atlanta-braves" },
    { name: "Baltimore Orioles", handle: "baltimore-orioles" },
    { name: "Boston Red Sox", handle: "boston-red-sox" },
    { name: "Chicago Cubs", handle: "chicago-cubs" },
    { name: "Chicago White Sox", handle: "chicago-white-sox" },
    { name: "Cincinnati Reds", handle: "cincinnati-reds" },
    { name: "Cleveland Guardians", handle: "cleveland-guardians" },
    { name: "Colorado Rockies", handle: "colorado-rockies" },
    { name: "Detroit Tigers", handle: "detroit-tigers" },
    { name: "Houston Astros", handle: "houston-astros" },
    { name: "Kansas City Royals", handle: "kansas-city-royals" },
    { name: "Los Angeles Angels", handle: "los-angeles-angels" },
    { name: "Los Angeles Dodgers", handle: "los-angeles-dodgers" },
    { name: "Miami Marlins", handle: "miami-marlins" },
    { name: "Milwaukee Brewers", handle: "milwaukee-brewers" },
    { name: "Minnesota Twins", handle: "minnesota-twins" },
    { name: "New York Mets", handle: "new-york-mets" },
    { name: "New York Yankees", handle: "new-york-yankees" },
    { name: "Oakland Athletics", handle: "oakland-athletics" },
    { name: "Athletics", handle: "athletics" },
    { name: "Philadelphia Phillies", handle: "philadelphia-phillies" },
    { name: "Pittsburgh Pirates", handle: "pittsburgh-pirates" },
    { name: "San Diego Padres", handle: "san-diego-padres" },
    { name: "San Francisco Giants", handle: "san-francisco-giants" },
    { name: "Seattle Mariners", handle: "seattle-mariners" },
    { name: "St. Louis Cardinals", handle: "st-louis-cardinals" },
    { name: "Tampa Bay Rays", handle: "tampa-bay-rays" },
    { name: "Texas Rangers", handle: "texas-rangers" },
    { name: "Toronto Blue Jays", handle: "toronto-blue-jays" },
    { name: "Washington Nationals", handle: "washington-nationals" }
  ],
  wnba: [
    { name: "Atlanta Dream", handle: "atlanta-dream" },
    { name: "Chicago Sky", handle: "chicago-sky" },
    { name: "Connecticut Sun", handle: "connecticut-sun" },
    { name: "Dallas Wings", handle: "dallas-wings" },
    { name: "Indiana Fever", handle: "indiana-fever" },
    { name: "Los Angeles Sparks", handle: "los-angeles-sparks" },
    { name: "Minnesota Lynx", handle: "minnesota-lynx" },
    { name: "New York Liberty", handle: "new-york-liberty" },
    { name: "Phoenix Mercury", handle: "phoenix-mercury" },
    { name: "Seattle Storm", handle: "seattle-storm" },
    { name: "Washington Mystics", handle: "washington-mystics" }
  ],
  nfl: [
    { name: "Arizona Cardinals", handle: "arizona-cardinals" },
    { name: "Atlanta Falcons", handle: "atlanta-falcons" },
    { name: "Baltimore Ravens", handle: "baltimore-ravens" },
    { name: "Buffalo Bills", handle: "buffalo-bills" },
    { name: "Carolina Panthers", handle: "carolina-panthers" },
    { name: "Chicago Bears", handle: "chicago-bears" },
    { name: "Cincinnati Bengals", handle: "cincinnati-bengals" },
    { name: "Cleveland Browns", handle: "cleveland-browns" },
    { name: "Dallas Cowboys", handle: "dallas-cowboys" },
    { name: "Denver Broncos", handle: "denver-broncos" },
    { name: "Detroit Lions", handle: "detroit-lions" },
    { name: "Green Bay Packers", handle: "green-bay-packers" },
    { name: "Houston Texans", handle: "houston-texans" },
    { name: "Indianapolis Colts", handle: "indianapolis-colts" },
    { name: "Jacksonville Jaguars", handle: "jacksonville-jaguars" },
    { name: "Kansas City Chiefs", handle: "kansas-city-chiefs" },
    { name: "Las Vegas Raiders", handle: "las-vegas-raiders" },
    { name: "Los Angeles Chargers", handle: "los-angeles-chargers" },
    { name: "Los Angeles Rams", handle: "los-angeles-rams" },
    { name: "Miami Dolphins", handle: "miami-dolphins" },
    { name: "Minnesota Vikings", handle: "minnesota-vikings" },
    { name: "New England Patriots", handle: "new-england-patriots" },
    { name: "New Orleans Saints", handle: "new-orleans-saints" },
    { name: "New York Giants", handle: "new-york-giants" },
    { name: "New York Jets", handle: "new-york-jets" },
    { name: "Philadelphia Eagles", handle: "philadelphia-eagles" },
    { name: "Pittsburgh Steelers", handle: "pittsburgh-steelers" },
    { name: "San Francisco 49ers", handle: "san-francisco-49ers" },
    { name: "Seattle Seahawks", handle: "seattle-seahawks" },
    { name: "Tampa Bay Buccaneers", handle: "tampa-bay-buccaneers" },
    { name: "Tennessee Titans", handle: "tennessee-titans" },
    { name: "Washington Commanders", handle: "washington-commanders" }
  ],
  college: [
    { name: "Alabama Crimson Tide", handle: "alabama-crimson-tide" },
    { name: "Arizona State Sun Devils", handle: "arizona-state-sun-devils" },
    { name: "Arizona Wildcats", handle: "arizona-wildcats" },
    { name: "Arkansas Razorbacks", handle: "arkansas-razorbacks" },
    { name: "Auburn Tigers", handle: "auburn-tigers" },
    { name: "Baylor Bears", handle: "baylor-bears" },
    { name: "Boise State Broncos", handle: "boise-state-broncos" },
    { name: "Boston College Eagles", handle: "boston-college-eagles" },
    { name: "Clemson Tigers", handle: "clemson-tigers" },
    { name: "Colorado Buffaloes", handle: "colorado-buffaloes" },
    { name: "Connecticut Huskies", handle: "connecticut-huskies" },
    { name: "Dayton Flyers", handle: "dayton-flyers" },
    { name: "Duke Blue Devils", handle: "duke-blue-devils" },
    { name: "Florida A&M Rattlers", handle: "florida-a-m-rattlers" },
    { name: "Florida Gators", handle: "florida-gators" },
    { name: "Florida State Seminoles", handle: "florida-state-seminoles" },
    { name: "Georgetown Hoyas", handle: "georgetown-hoyas" },
    { name: "Georgia Tech Yellow Jackets", handle: "georgia-tech-yellow-jackets" },
    { name: "Gonzaga Bulldogs", handle: "gonzaga-bulldogs" },
    { name: "Hampton Pirates", handle: "hampton-pirates" },
    { name: "Houston Cougars", handle: "houston-cougars" },
    { name: "Howard Bison", handle: "howard-bison" },
    { name: "Howard Bisons", handle: "howard-bisons" },
    { name: "Illinois Fighting Illini", handle: "illinois-fighting-illini" },
    { name: "Indiana Hoosiers", handle: "indiana-hoosiers" },
    { name: "Iowa Hawkeyes", handle: "iowa-hawkeyes" },
    { name: "Iowa State Cyclones", handle: "iowa-state-cyclones" },
    { name: "Jackson State Tigers", handle: "jackson-state-tigers" },
    { name: "Kansas Jayhawks", handle: "kansas-jayhawks" },
    { name: "Kansas State Wildcats", handle: "kansas-state-wildcats" },
    { name: "Kentucky Wildcats", handle: "kentucky-wildcats" },
    { name: "Liberty Flames", handle: "liberty-flames" },
    { name: "Louisville Cardinals", handle: "louisville-cardinals" },
    { name: "LSU Tigers", handle: "lsu-tigers" },
    { name: "Marquette Eagles", handle: "marquette-eagles" },
    { name: "Marquette Golden Eagles", handle: "marquette-golden-eagles" },
    { name: "Maryland Terrapins", handle: "maryland-terrapins" },
    { name: "Memphis Tigers", handle: "memphis-tigers" },
    { name: "Miami Hurricanes", handle: "miami-hurricanes" },
    { name: "Michigan State Spartans", handle: "michigan-state-spartans" },
    { name: "Michigan Wolverines", handle: "michigan-wolverines" },
    { name: "Minnesota Gophers", handle: "minnesota-gophers" },
    { name: "Minnesota Golden Gophers", handle: "minnesota-golden-gophers" },
    { name: "Mississippi Bulldogs", handle: "mississippi-bulldogs" },
    { name: "Mississippi State Bulldogs", handle: "mississippi-state-bulldogs" },
    { name: "Mississippi Rebels", handle: "mississippi-rebels" },
    { name: "Missouri Tigers", handle: "missouri-tigers" },
    { name: "Morgan State Bears", handle: "morgan-state-bears" },
    { name: "NC State Wolfpack", handle: "nc-state-wolfpack" },
    { name: "Nebraska Cornhuskers", handle: "nebraska-cornhuskers" },
    { name: "North Carolina Central Eagles", handle: "north-carolina-central-eagles" },
    { name: "North Carolina Tar Heels", handle: "north-carolina-tar-heels" },
    { name: "Northwestern Wildcats", handle: "northwestern-wildcats" },
    { name: "Notre Dame Fighting Irish", handle: "notre-dame-fighting-irish" },
    { name: "Ohio State Buckeyes", handle: "ohio-state-buckeyes" },
    { name: "Oklahoma State Cowboys", handle: "oklahoma-state-cowboys" },
    { name: "Oregon State Beavers", handle: "oregon-state-beavers" },
    { name: "Penn State Nittany Lions", handle: "penn-state-nittany-lions" },
    { name: "Pittsburgh Panthers", handle: "pittsburgh-panthers" },
    { name: "Purdue Boilmakers", handle: "purdue-boilmakers" },
    { name: "Purdue Boilermakers", handle: "purdue-boilermakers" },
    { name: "Rutgers Scarlet Knights", handle: "rutgers-scarlet-knights" },
    { name: "San Diego State Aztecs", handle: "san-diego-state-aztecs" },
    { name: "South Carolina Gamecocks", handle: "south-carolina-gamecocks" },
    { name: "Southern Methodist Mustangs", handle: "southern-methodist-mustangs" },
    { name: "Stanford Cardinal", handle: "stanford-cardinal" },
    { name: "Syracuse Orange", handle: "syracuse-orange" },
    { name: "TCU Horned Frogs", handle: "tcu-horned-frogs" },
    { name: "Tennessee Volunteers", handle: "tennessee-volunteers" },
    { name: "Texas A&M Aggies", handle: "texas-a-m-aggies" },
    { name: "Texas Longhorns", handle: "texas-longhorns" },
    { name: "Texas Tech Red Raiders", handle: "texas-tech-red-raiders" },
    { name: "Tuskegee Golden Tigers", handle: "tuskegee-golden-tigers" },
    { name: "UCLA Bruins", handle: "ucla-bruins" },
    { name: "UNLV Rebels", handle: "unlv-rebels" },
    { name: "UNLV Runnin' Rebels", handle: "unlv-runnin-rebels" },
    { name: "USC Trojans", handle: "usc-trojans" },
    { name: "Utah Utes", handle: "utah-utes" },
    { name: "Vanderbilt Commodores", handle: "vanderbilt-commodores" },
    { name: "Virginia Cavaliers", handle: "virginia-cavaliers" },
    { name: "Virginia Tech Hokies", handle: "virginia-tech-hokies" },
    { name: "Villanova Wildcats", handle: "villanova-wildcats" },
    { name: "Wake Forest Demon Deacons", handle: "wake-forest-demon-deacons" },
    { name: "Washington Huskies", handle: "washington-huskies" },
    { name: "West Virgina Mountaineers", handle: "west-virgina-mountaineers" },
    { name: "West Virginia Mountaineers", handle: "west-virginia-mountaineers" },
    { name: "Wyoming Cowboys", handle: "wyoming-cowboys" }
  ],
  "international-soccer": [
    { name: "AC Milan", handle: "ac-milan" },
    { name: "Atlas FC", handle: "atlas-fc" },
    { name: "AS Roma", handle: "as-roma" },
    { name: "Celtic FC", handle: "celtic-fc" },
    { name: "Chelsea FC", handle: "chelsea-fc" },
    { name: "Guadalajara Chivas", handle: "guadalajara-chivas" },
    { name: "Club America", handle: "club-america" },
    { name: "Club Leon", handle: "club-leon" },
    { name: "Club Necaxa", handle: "club-necaxa" },
    { name: "Club Pachuca", handle: "club-pachuca" },
    { name: "Club Puebla", handle: "club-puebla" },
    { name: "Club Puebla FC", handle: "club-puebla-fc" },
    { name: "Queretaro Gallos Blancos", handle: "queretaro-gallos-blancos" },
    { name: "Club Queretaro", handle: "club-queretaro" },
    { name: "Tigres de la UANL", handle: "tigres-de-la-uanl" },
    { name: "Club Tigres UANL", handle: "club-tigres-uanl" },
    { name: "Cruz Azul", handle: "cruz-azul" },
    { name: "Club Deportivo Toluca", handle: "club-deportivo-toluca" },
    { name: "Deportivo Toluca FC", handle: "deportivo-toluca-fc" },
    { name: "Dublin GAA", handle: "dublin-gaa" },
    { name: "Manchester United", handle: "manchester-united" },
    { name: "Newcastle United FC", handle: "newcastle-united-fc" },
    { name: "Newcastle United", handle: "newcastle-united" },
    { name: "Pumas", handle: "pumas" },
    { name: "Rayados", handle: "rayados" },
    { name: "Santos Laguna", handle: "santos-laguna" },
    { name: "Tottenham Hotspur", handle: "tottenham-hotspur" },
    { name: "Tijuana Xolos", handle: "tijuana-xolos" },
    { name: "Xolos", handle: "xolos" }
  ],
  mls: [
    { name: "Atlanta United FC", handle: "atlanta-united-fc" },
    { name: "Austin FC", handle: "austin-fc" },
    { name: "CF Montreal", handle: "cf-montreal" },
    { name: "Charlotte FC", handle: "charlotte-fc" },
    { name: "Chicago Fire", handle: "chicago-fire" },
    { name: "Chicago Fire FC", handle: "chicago-fire-fc" },
    { name: "Colorado Rapids", handle: "colorado-rapids" },
    { name: "Columbus Crew", handle: "columbus-crew" },
    { name: "D.C. United", handle: "d-c-united" },
    { name: "FC Cincinnati", handle: "fc-cincinnati" },
    { name: "FC Dallas", handle: "fc-dallas" },
    { name: "Houston Dynamo", handle: "houston-dynamo" },
    { name: "Houston Dynamo FC", handle: "houston-dynamo-fc" },
    { name: "Inter Miami", handle: "inter-miami" },
    { name: "LA Galaxy", handle: "la-galaxy" },
    { name: "Los Angeles FC", handle: "los-angeles-fc" },
    { name: "Minnesota United FC", handle: "minnesota-united-fc" },
    { name: "Nashville SC", handle: "nashville-sc" },
    { name: "New England Revolution", handle: "new-england-revolution" },
    { name: "New York City FC", handle: "new-york-city-fc" },
    { name: "New York Red Bulls", handle: "new-york-red-bulls" },
    { name: "Orlando City SC", handle: "orlando-city-sc" },
    { name: "Philadelphia Union", handle: "philadelphia-union" },
    { name: "Portland Timbers", handle: "portland-timbers" },
    { name: "Real Salt Lake", handle: "real-salt-lake" },
    { name: "San Diego FC", handle: "san-diego-fc" },
    { name: "San Jose Earthquakes", handle: "san-jose-earthquakes" },
    { name: "Seattle Sounders", handle: "seattle-sounders" },
    { name: "Seattle Sounders FC", handle: "seattle-sounders-fc" },
    { name: "Sporting Kansas City", handle: "sporting-kansas-city" },
    { name: "St. Louis City FC", handle: "st-louis-city-fc" },
    { name: "St. Louis City SC", handle: "st-louis-city-sc" },
    { name: "Toronto FC", handle: "toronto-fc" },
    { name: "Vancouver Whitecaps FC", handle: "vancouver-whitecaps-fc" }
  ]
};

/**
 * Returns the league key a team handle belongs to, or null when unknown.
 * @param {string} teamHandle
 * @returns {string | null}
 */
function findTeamLeague(teamHandle) {
  for (const [league, teams] of Object.entries(TEAMS_BY_LEAGUE)) {
    if (teams.some(team => team.handle === teamHandle)) {
      return league;
    }
  }
  return null;
}

/**
 * Looks a team up by handle, tagging it with the league it was found under.
 * @param {string} teamHandle
 * @returns {AssetsTeamWithLeague | null}
 */
function getTeamByHandle(teamHandle) {
  for (const [league, teams] of Object.entries(TEAMS_BY_LEAGUE)) {
    const team = teams.find(team => team.handle === teamHandle);
    if (team) {
      return { ...team, league };
    }
  }
  return null;
}

/**
 * Buckets a flat list of team handles by league. Handles with no known league
 * are dropped.
 * @param {string[]} allTeams
 * @returns {AssetsLeagueTeams}
 */
function populateLeagueTeams(allTeams) {
  /** @type {AssetsLeagueTeams} */
  const leagueTeams = {
    mlb_teams: [],
    nfl_teams: [],
    nba_teams: [],
    nhl_teams: [],
    wnba_teams: [],
    milb_teams: [],
    mls_teams: [],
    college_teams: [],
    motorsport_teams: [],
    international_soccer_teams: []
  };

  allTeams.forEach(teamHandle => {
    const league = findTeamLeague(teamHandle);
    if (league) {
      switch (league) {
        case 'mlb':
          leagueTeams.mlb_teams.push(teamHandle);
          break;
        case 'nfl':
          leagueTeams.nfl_teams.push(teamHandle);
          break;
        case 'nba':
          leagueTeams.nba_teams.push(teamHandle);
          break;
        case 'nhl':
          leagueTeams.nhl_teams.push(teamHandle);
          break;
        case 'wnba':
          leagueTeams.wnba_teams.push(teamHandle);
          break;
        case 'milb':
          leagueTeams.milb_teams.push(teamHandle);
          break;
        case 'mls':
          leagueTeams.mls_teams.push(teamHandle);
          break;
        case 'college':
          leagueTeams.college_teams.push(teamHandle);
          break;
        case 'international-soccer':
          leagueTeams.international_soccer_teams.push(teamHandle);
          break;
      }
    }
  });

  return leagueTeams;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { TEAMS_BY_LEAGUE, findTeamLeague, getTeamByHandle, populateLeagueTeams };
}

if (typeof window !== 'undefined') {
  window.teamsMapping = {
    findTeamLeague,
    getTeamByHandle,
    populateLeagueTeams
  };
}